module.exports = __webpack_public_path__ + "img/list02.c0dbe6d5.jpg";